var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 33.334V5.83398H5V34.1673C5 34.6276 5.3731 35.0007 5.83333 35.0007H34.1667V33.334H6.66667Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3103 22.6122L6.47698 29.6956L5.19043 28.6361L11.0238 21.5527L12.3103 22.6122Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5127 23.6863L15.5127 21.603L16.1537 20.0645L21.1537 22.1478L20.5127 23.6863Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6511 15.9377L25.6511 22.1877L24.3496 21.1465L29.3496 14.8965L30.6511 15.9377Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 21.666C14.2538 21.666 15 20.9198 15 19.9993C15 19.0788 14.2538 18.3327 13.3333 18.3327C12.4128 18.3327 11.6667 19.0788 11.6667 19.9993C11.6667 20.9198 12.4128 21.666 13.3333 21.666ZM13.3333 23.3327C15.1742 23.3327 16.6667 21.8403 16.6667 19.9993C16.6667 18.1584 15.1742 16.666 13.3333 16.666C11.4924 16.666 10 18.1584 10 19.9993C10 21.8403 11.4924 23.3327 13.3333 23.3327Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 25C24.2538 25 25 24.2538 25 23.3333C25 22.4128 24.2538 21.6667 23.3333 21.6667C22.4128 21.6667 21.6667 22.4128 21.6667 23.3333C21.6667 24.2538 22.4128 25 23.3333 25ZM23.3333 26.6667C25.1742 26.6667 26.6667 25.1742 26.6667 23.3333C26.6667 21.4924 25.1742 20 23.3333 20C21.4924 20 20 21.4924 20 23.3333C20 25.1742 21.4924 26.6667 23.3333 26.6667Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6663 15C32.5868 15 33.333 14.2538 33.333 13.3333C33.333 12.4128 32.5868 11.6667 31.6663 11.6667C30.7458 11.6667 29.9997 12.4128 29.9997 13.3333C29.9997 14.2538 30.7458 15 31.6663 15ZM31.6663 16.6667C33.5073 16.6667 34.9997 15.1742 34.9997 13.3333C34.9997 11.4924 33.5073 10 31.6663 10C29.8254 10 28.333 11.4924 28.333 13.3333C28.333 15.1742 29.8254 16.6667 31.6663 16.6667Z",
    fill: "#040E64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/chart_line.67df3725da135ab14cb349cd62ca0057.svg";
export { ForwardRef as ReactComponent };